<template>
    <div>
        <Plotly :data="data" :layout="layout" :display-mode-bar="false"></Plotly>
    </div>
</template>
<script>
import { Plotly } from 'vue-plotly'
export default {
    props:{
        deviceMap:Object,
        devices:Object,
        deviceID:Number
    },
    components: {
        Plotly
    },
    watch:{
        devices: {
            handler: function (val) {
                let vm = this
                let result = Object.values(vm.deviceMap)
                vm.$set(vm.data[0], 'x', result)
                let result2 = []
                Object.keys(vm.deviceMap).forEach(function (sensor) {
                    result2.push(val[vm.deviceID][sensor].min)
                })
                vm.$set(vm.data[0], 'y', result2)
                vm.$set(vm.data[0], 'text', result2.map(String))
            },
            deep: true
        }
    },
    data(){
        let vm = this
        return {
            data: [{
            x: [],
            y: [],
            type: "bar",
            text: [].map(String),
            textposition: 'auto',
            hoverinfo: 'none',
            marker: {
                color: ['rgba(204,204,204,1)', 'rgba(222,45,38,0.8)', 'rgba(204,204,204,1)', 'rgba(204,204,204,1)', 'rgba(204,204,204,1)'],
                opacity: 0.6,
                line: {
                    color: 'rgb(8,48,107)',
                    width: 1.5
                }
            }
        }],
        layout: {
            title: "Minimum Values"
        }
        }
    },
    methods:{
        updateChart(){
                let vm = this
                let result = Object.values(vm.deviceMap)
                vm.$set(vm.data[0], 'x', result)
                let result2 = []
                Object.keys(vm.deviceMap).forEach(function (sensor) {
                    result2.push(vm.devices[vm.deviceID][sensor].max)
                })
                vm.$set(vm.data[0], 'y', result2)
                vm.$set(vm.data[0], 'text', result2.map(String))
        }
    },
    mounted(){
        let vm = this
        vm.updateChart()
    }
}

</script>
